import React, { useEffect, useState } from 'react'
import {
    Grid, FormControl, Checkbox, FormControlLabel,
    makeStyles, Box, Button,
    Typography,
    Paper,
    Divider
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import ProfileUpdateInfo from '../../components/ProfileUpdateInfo/ProfileUpdateInfo'
import { getfilterSpeciality, updateSpeciality } from '../../store/action';
import Notify from '../../components/Notify/Notify';
import { apiClient } from '../../config/apiClient';
import Loading from '../../components/Loading';


const useStyle = makeStyles((theme) => ({
    section: {
        padding: theme.spacing(1, 0),
    },
    sectionTitle: {
        marginBottom: theme.spacing(1),
    },
    orgNameBox: {
        display: "flex"
    },
    orgTitle: {
        fontWeight: 600,
        marginRight:theme.spacing(1)
    },
}));

const Specialities = () => {
    const classes = useStyle()
    const dispatch = useDispatch();
    const getId = JSON.parse(window.localStorage.getItem('signeeInfo'));
    const getOrg = JSON.parse(window.localStorage.getItem('signeeInfo'));
    const { getFilterSpeciality, filterLoader } = useSelector(state => state.browseShift)
    const { updateSpeSuccess, updateSpeError} = useSelector(state => state.organization)
    const [msgNotify, setMsgNotify] = useState(false)
    const [data, setData] = useState({
        speciality_id: []
    })

    const handleChangeCheckbox = (event) => {
        const specialData = JSON.parse(JSON.stringify(data))
        const isChecked = event.target.checked
        if (isChecked) {
            specialData.speciality_id.push(parseFloat(event.target.value))
            setData(specialData)
        } else {
            const newData = (specialData.speciality_id).filter(item => item !== parseFloat(event.target.value));
            specialData.speciality_id = newData;
            setData(specialData)
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        dispatch(updateSpeciality(data, getId.id))
        setMsgNotify(true)
    }

    const getSigneeSpeciality = async () => {
        await apiClient(true).get(`api/signee/get-signee-speciality`)
            .then(response => {
                let speciality = [];
                if (response.data.status === true) {
                    response.data.data.map(val => {
                        speciality.push(val.speciality_id);
                    })
                }
                console.log(speciality)
                data.speciality_id = speciality
                dispatch(getfilterSpeciality())
            }).catch(error => {
                console.log('error: ', error);

            })
    }

    useEffect(() => {
        getSigneeSpeciality()
    }, [])


    return (
        <>
        {filterLoader && <Loading open={filterLoader} />}
            
        {msgNotify && (updateSpeError?.message || updateSpeError) &&
            <Notify data={updateSpeError?.message ? updateSpeError?.message : updateSpeError} status="error"/>
        }

        {msgNotify && (updateSpeSuccess?.message || updateSpeSuccess) &&
            <Notify data={updateSpeSuccess?.message ? updateSpeSuccess?.message : updateSpeSuccess} status="success"/>
        }
        
        <ProfileUpdateInfo />
        
        <section className={classes.section}>
            <Typography variant="h5" className={classes.sectionTitle}>Update Specialities</Typography>

            <form onSubmit={(e) => handleSubmit(e)}>
                <Paper className={classes.mainBox}>
                    <Grid container spacing={3}>
                        {/* Organization Name */}
                        <Grid item xs={12}>
                            <Box className={classes.orgNameBox}>
                                <Typography className={classes.orgTitle}>
                                    Organization Name:
                                </Typography>
                                <Typography className={classes.orgName}>
                                    {getOrg.organization_name}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider />
                        </Grid>

                        {/* Specialities List */}
                        <Grid item xs={12}>
                            <Grid container spacing={2}>
                                {getFilterSpeciality?.data && getFilterSpeciality.data.length > 0 ? (
                                    getFilterSpeciality.data.map((list, index) => (
                                        <Grid item xs={12} sm={6} md={2} key={index}>
                                            <FormControl component="fieldset" className={classes.formControl}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            onChange={handleChangeCheckbox}
                                                            checked={data.speciality_id.includes(list.id)}
                                                            value={list?.id}
                                                            color="primary"
                                                            name="speciality_id"
                                                        />
                                                    }
                                                    label={list?.speciality_name}
                                                    className={classes.checkboxLabel}
                                                />
                                            </FormControl>
                                        </Grid>
                                    ))
                                ) : (
                                    <Grid item xs={12}>
                                        <p
                                            style={{
                                                color: "#999",
                                                fontSize: "0.9rem",
                                                fontStyle: "italic",
                                                padding: "6px 0",
                                                textAlign: "center",
                                            }}
                                        >
                                            No specialities found with this organization
                                        </p>
                                    </Grid>
                                )}
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* Submit Button */}
                    {getFilterSpeciality?.data?.length > 0 && 
                    <Box className="mt-16 text-right">
                        <Button className={classes.btnSecondary} variant="contained" type="submit" formNoValidate>
                            Update
                        </Button>
                    </Box>}
                </Paper>
            </form>
        </section>
        </>
    )
}

export default Specialities
